<template>
    <div id="app">
        <Layout class="app-frame" :siderCollapsed="sliderCollapsed" :siderFixed="layoutConfig.siderFixed">
            <Sider :theme="layoutConfig.siderTheme">
                <appMenu :theme="layoutConfig.siderTheme" v-if="this.User.special != '1111'"></appMenu>
                <appSpecialMenu :theme="layoutConfig.siderTheme" v-else></appSpecialMenu>
            </Sider>
            <Layout :headerFixed="layoutConfig.headerFixed">
                <HHeader theme="white">
                    <appHead @openSetting="openSetting=true" :layoutConfig="layoutConfig"></appHead>
                </HHeader>
                <SysTabs v-if="layoutConfig.showSystab" homePage="Home"></SysTabs>
                <Content>
                    <!--<keep-alive class="app-frame-content ">-->
                    <!--<router-view v-if="isRouterAlive"></router-view>-->
                    <!--</keep-alive>-->
                    <div class="app-frame-content ">
                        <router-view v-if="isRouterAlive"></router-view>
                    </div>
                </Content>
                <HFooter>
                    <appFooter></appFooter>
                </HFooter>
            </Layout>
        </Layout>
        <Modal v-model="openSetting" type="drawer-right">
            <appLayoutSetting :layoutConfig="layoutConfig"></appLayoutSetting>
        </Modal>
    </div>
</template>
<script>
    import appLayoutSetting from './app/modules/app-layout-setting';
    import appHead from './app/app-header';
    import appMenu from './app/app-menu';
    import appSpecialMenu from './app/app-special-menu';
    import appFooter from './app/app-footer';
    import {mapState} from 'vuex';
    import SysTabs from './app/sys-tabs/sys-tabs';

    export default {
        name: "FXY",
        provide() {
            return {
                reload: this.reload
            }
        },
        data() {
            return {
                openSetting: false,
                isRouterAlive: true,
                layoutConfig: {
                    siderTheme: 'white',
                    showSystab: true,
                    headerFixed: true,
                    siderFixed: false,
                }
            };
        },
        mounted() {//打开可以使用全局配置
            this.initDict();
        },
        methods: {
            updateLayoutConfig({key, value}) {
                this.layoutConfig[key] = value;
            },
            reload() {
                this.isRouterAlive = false;
                this.$nextTick(() => {
                    this.isRouterAlive = true;
                });
            },
            initDict() {  //加载配置文件 、未用到
                this.$api.common.dict().then(resp => {
                    if (resp.success) {
                        let dicts = resp.data;
                        for (let dict of dicts) {
                            HeyUI.addDict(dict.name, dict.value);
                        }
                    }
                });
                HeyUI.addDict('QuestionBankType',
                    [{title: '单选题', key: 0},
                    {title: '多选题', key: 1},
                    {title: '判断题', key: 2},
                    {title: '不定项题', key: 3},
                    {title: '计算分析题', key: 4},
                    {title: '问答题', key: 6},
                    {title: '综合题', key: 5}
                    ]);
            },
            initMenu() {
                // 如果使用权限配置，配合后端获取请求的数据
                // R.Account.menus().then(resp => {
                //   if (resp.ok) {
                //     this.menus = getMenus(resp.body);
                //     this.menuSelect();
                //   }
                // });
                // let menus = Utils.getLocal2Json('SYS_CONFIG_MENU') || fullMenuKeys;
                // G.set('SYS_MENUS', menus);
                // G.trigger('SYS_MENU_UPDATE');
                // if (!isAuthPage(this.$route.name)) {
                //   this.$router.replace({ name: 'PermissionError' });
                // }
            }
        },
        computed: {
            ...mapState(['sliderCollapsed','User'])
        },
        components: {
            appHead,
            appMenu,
            appSpecialMenu,
            appFooter,
            SysTabs,
            appLayoutSetting
        }
    };
</script>
